import React, { useState } from "react";
import "../../Assets/Style/GetRates.scss";
import { TextArea, Textbox } from "../../components/FormInputs";
import Button from "../../components/Button";
import Header from "../../components/Header";
import HomeFooter from "../../components/Footer";
import Aramex from "../../Assets/Img/aramex3.png";
import DHL from "../../Assets/Img/dhl3.png";
import UPS from "../../Assets/Img/ups3.png";
import Fedex from "../../Assets/Img/fedex3.png";

const GetRates = () => {
  const [formData, setFormData] = useState({
    pickup_city: "",
    pickup_country: "",
    dropoff_city: "",
    dropoff_country: "",
    weight: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <div>
      <Header />
      <div className="GetRatesWrapper">
        <div className="RatesSection">
          <h1 className="InfoHero">Get Quotes</h1>
          <p className="InfoSub">
          Get an estimate of shipping cost to find out how much it cost to delivery your packages
          </p>
          <div className="RatesFormContain">
            <div className="GetRatesForm">
              <div>
                <div className="FormContain">
                  <div className="FormGrid">
                    <Textbox
                      name="pickup_country"
                      label="Pickup Country"
                      value={formData.pickup_country}
                      onChange={handleChange}
                    />
                    <Textbox
                      name="pickup_city"
                      label="Pickup City"
                      value={formData.pickup_city}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="FormGrid">
                    <Textbox
                      name="dropoff_country"
                      label="Dropoff Country"
                      value={formData.dropoff_country}
                      onChange={handleChange}
                    />
                    <Textbox
                      name="dropoff_city"
                      label="Dropoff City"
                      value={formData.dropoff_city}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="TextAreaContain">
                    <Textbox
                      name="weight"
                      label="Weight"
                      value={formData.weight}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="BtnWrap">
                    <Button
                      text="CALCULATE RATE"
                      color={"#E92D38"}
                      width={"100%"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="CarrierSection">
          <div className="CarrierWrap" >
            <div className="CarriersContain">
              <img src={DHL} alt="dhl" />
              <div>
                <p className="CarrierName">DHL Express</p>
                <p className="CarrierInfo">Best of time sensitive</p>
              </div>
              <div>
                <p className="WorkDays"> 3 to 7 working days</p>
              </div>
              <div>
                <p className="CarrierAmount">N45,111</p>
              </div>
            </div>
            <div className="CarriersContain">
              <img src={Aramex} alt="aramex" className="CarrierImg" />
              <div>
                <p className="CarrierName">Aramex</p>
                <p className="CarrierInfo">Best of time sensitive</p>
              </div>
              <div>
                <p className="WorkDays"> 3 to 7 working days</p>
              </div>
              <div>
                <p className="CarrierAmount">N45,111</p>
              </div>
            </div>
            <div className="CarriersContain">
              <img src={Fedex} alt="fedex" />
              <div>
                <p className="CarrierName">FedEx</p>
                <p className="CarrierInfo">Best of time sensitive</p>
              </div>
              <div>
                <p className="WorkDays"> 3 to 7 working days</p>
              </div>
              <div>
                <p className="CarrierAmount">N45,111</p>
              </div>
            </div>
            <div className="CarriersContain">
              <img src={UPS} alt="ups" />
              <div>
                <p className="CarrierName">UPS</p>
                <p className="CarrierInfo">Best of time sensitive</p>
              </div>
              <div>
                <p className="WorkDays"> 3 to 7 working days</p>
              </div>
              <div>
                <p className="CarrierAmount">N45,111</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeFooter />
    </div>
  );
};

export default GetRates;
